import React from 'react';
import Attribute from './common';
import { SubTitle, SubText } from '../../../common';

const notice = {
    catC: {
        title: 'Category C',
        description: `The vehicle is repairable but the costs exceed
		the vehicle’s value. Can re-appear on road.`,
    },
    catD: {
        title: 'Category D',
        description: `The vehicle is repairable but repair costs are
		significant compared to the vehicle value – including time delays
		to source parts. Can re-appear on road.`,
    },
};

interface NoticeContents {
    title: string;
    description: string;
}

interface Notice {
    catC: NoticeContents;
    catD: NoticeContents;
}

interface Props {
    passed: boolean;
}

interface NotCatCDProps {
    passed: boolean;
}

const NotCatCD: React.FC<Props> = ({
    passed
}: NotCatCDProps) => {
    const { catC, catD }: Notice = notice;
    return (
        <Attribute name="Not Cat C/D" passed={passed}>
            <SubTitle>{catC.title}</SubTitle>
            <SubText>{catC.description}</SubText>
            <SubTitle>{catD.title}</SubTitle>
            <SubText>{catD.description}</SubText>
        </Attribute>
    );
};

export default NotCatCD;
